import ReactGA from "react-ga4";

// Initialize GA
export const initGA = () => {
  try {
    ReactGA.initialize("G-G56PRHVHCZ", {
      gtagOptions: {
        send_page_view: false // We'll handle this manually
      }
    });

    // Set default parameters
    ReactGA.set({
      app_version: process.env.REACT_APP_VERSION || '1.0',
      platform: 'web'
    });

  } catch (error) {
    console.error('GA initialization failed:', error);
  }
};

// Page View Tracking (Fixed)
export const logPageView = (title = '', bookId = null) => {
  try {
    ReactGA.send({
      hitType: "pageview", 
      page_title: title || document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
      book_id: bookId || 'none'
    });
  } catch (error) {
    console.error('GA pageview tracking failed:', error);
  }
};

// Event Tracking (Fixed)
export const logEvent = (category, action, label, value = null) => {
  try {
    ReactGA.event({
      category,
      action,
      label,
      value: value !== null && !isNaN(value) ? Number(value) : undefined 
    });
  } catch (error) {
    console.error('GA event tracking failed:', error);
  }
};

// Other tracking functions remain unchanged
export const trackUserInteraction = (type, details) => {
  logEvent('user_interaction', type, details);
};

export const trackAudioEvent = (action, sceneId, chapter, duration) => {
  logEvent('audio_interaction', action, `Scene: ${sceneId}, Chapter: ${chapter}`, duration);
};

export const trackNavigation = (from, to) => {
  logEvent('navigation', 'page_change', `From: ${from} To: ${to}`);
};

export const trackSettingChange = (setting, newValue) => {
  logEvent('settings_change', setting, String(newValue));
};

export const trackError = (error, context) => {
  logEvent('error', error.name || 'unknown_error', `${error.message} | Context: ${context}`);
};

export const trackBookInteraction = (action, bookId) => {
  logEvent('book_interaction', action, `Book ID: ${bookId}`);
};

export const trackReadingProgress = (chapter, sceneId, timeSpent) => {
  logEvent('reading_progress', 'scene_complete', `Chapter: ${chapter} - Scene: ${sceneId}`, timeSpent);
};

export const trackUserPreference = (preference, value) => {
  logEvent('user_preference', preference, String(value));
};

export const trackUIInteraction = (element, action) => {
  logEvent('ui_interaction', element, action);
};

export const trackTiming = (category, variable, value) => {
  try {
    ReactGA.event('timing_complete', {
      name: variable,
      value: Math.round(value),
      category: category
    });
  } catch (error) {
    console.error('GA timing tracking failed:', error);
  }
};
